import { Trans } from '@lingui/macro'

import styled from '@emotion/styled'
import * as React from 'react'

import { SpeedloSpinner as ShopSpeedloSpinner } from '~shared/components/Validation/SpeedloSpinner'
import { Grid, GridCentered } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TStyledProps = {
  shouldShowText?: boolean
}

const propForwardOptions = {
  shouldForwardProp: (propName: string) => propName !== `shouldShowText`,
}

/**
 * Text with the conditionally controlled opacity & its transition.
 * Use `shouldShowText` boolean.
 */
const StyledText = styled(Text, propForwardOptions)<TStyledProps>`
  transition: opacity 0.5s;
  opacity: ${({ shouldShowText }) => (shouldShowText ? 1 : 0)};
`

type TProps = NoChildren & {
  message?: React.ReactNode
}

const SHOW_SUB_LABEL_DELAY = 5000 //ms

/**
 * Loading state while we are waiting for an operation to finish.
 * - Renders message with the speedlo spinner.
 * - Adds sub-label if the validation takes longer than 5s.
 */
export const Validating: React.FC<TProps> = ({ message }) => {
  const [shouldShowSubLabel, setShouldShowSubLabel] = React.useState(false)

  // show "please wait" message with a delay, to keep the customer patient a little longer
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldShowSubLabel(true)
    }, SHOW_SUB_LABEL_DELAY)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <GridCentered rowGap={`large`}>
      <ShopSpeedloSpinner />

      <Grid rowGap={`smallMedium`}>
        {message}

        <StyledText
          textAlign={`center`}
          fontSize={`m18`}
          fontStyle={`regular`}
          contrast={`low`}
          shouldShowText={shouldShowSubLabel}
        >
          <Trans>please wait</Trans>
        </StyledText>
      </Grid>
    </GridCentered>
  )
}
